import React from 'react';
import PropTypes from 'prop-types';

import { parseStyleString } from '../../helpers/attributes';
import { rowShape } from '../../helpers/table_override_helper';
import TableCell from './cell';

export default class TableSection extends React.Component {
  static propTypes = {
    buildCellProps: PropTypes.func.isRequired,
    cellContentById: PropTypes.object.isRequired,
    className: PropTypes.string.isRequired,
    defaultRows: PropTypes.arrayOf(rowShape).isRequired,
    getCellKey: PropTypes.func.isRequired,
    overrideRows: PropTypes.arrayOf(rowShape),
    sanitize: PropTypes.bool.isRequired,
    section: PropTypes.oneOf(['bodyRows', 'headerRows']).isRequired,
    selectable: PropTypes.bool,
    selected: PropTypes.bool,
    selectedColumnIndex: PropTypes.number,
    selectedRowIndex: PropTypes.number,

    onCellBlur: PropTypes.func.isRequired,
    onCellContentEditStart: PropTypes.func.isRequired,
    onCellFocus: PropTypes.func.isRequired,
    onCellOverrideChange: PropTypes.func.isRequired,
    onCellOverrideReset: PropTypes.func.isRequired,
    onCellSelect: PropTypes.func.isRequired
  }

  static defaultProps = {
    buildCellProps: () => {}
  }

  render() {
    const TagName = this.props.section === 'headerRows' ? 'thead' : 'tbody';
    return (
      <TagName className={this.props.className}>
        {this.renderRows()}
      </TagName>
    );
  }

  renderRows() {
    return (this.props.overrideRows || this.props.defaultRows).map((row, i) => (
      <tr className={row.class} key={i} style={parseStyleString(row.style)}>
        {this.renderCells(row.cells, i)}
      </tr>
    ));
  }

  renderCells(cells, rowIndex) {
    const inSelectedRow = this.props.selected && rowIndex === this.props.selectedRowIndex;

    return cells.map((cell, i) => {
      const inSelectedColumn = i === this.props.selectedColumnIndex;
      const eventData = {
        columnIndex: i,
        rowIndex,
        section: this.props.section
      };

      const cellProps = this.props.buildCellProps(cell, rowIndex, i);

      return (
        <TableCell
          className={cell.class}
          defaultHtml={this.props.cellContentById[cell.id] || ''}
          eventData={eventData}
          inSelectedColumn={inSelectedColumn}
          inSelectedRow={inSelectedRow}
          key={this.props.getCellKey(cell, rowIndex, i)}
          sanitize={this.props.sanitize}
          selectable={this.props.selectable}
          selected={inSelectedColumn && inSelectedRow}
          style={parseStyleString(cell.style)}
          override={cell.html}
          tagName={this.props.section === 'headerRows' ? 'th' : 'td'}
          onBlur={this.props.onCellBlur}
          onContentEditStart={this.props.onCellContentEditStart}
          onFocus={this.props.onCellFocus}
          onOverrideChange={this.props.onCellOverrideChange}
          onOverrideReset={this.props.onCellOverrideReset}
          onSelect={this.props.onCellSelect}
          {...cellProps}
        />
      );
    });
  }
}
